module.exports = __webpack_public_path__ + "img/img-intro-app-3-jp.c5826348.svg";